
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/informacje-motoryzacja",
      function () {
        return require("private-next-pages/informacje-motoryzacja/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/informacje-motoryzacja"])
      });
    }
  